import React from "react";
import "./Profcyma_Partner_Program.css";
import Common_Title from "../../common_components/common_title/Common_Title";

const Profcyma_Partner_Program = () => {
  const points = [
    {
      bold: "Counsel & guide students",
      text: "toward the ideal university and online program based on their career goals.",
    },
    {
      bold: "Earn recurring commissions every semester",
      text: "for each enrolled student — a long-term passive income model.",
    },
    {
      bold: "Accelerate growth",
      text: "with our full support system: training, marketing, CRM, and managers.",
    },
  ];

  return (
    <section className="Profcyma_Partner_Program">
      <div className="container">
        <div className="main_content_div">
          <div className="text_holder">
            <div className="section_title_div">
              <Common_Title
                simpleText="What is the  "
                darkText="Profcyma Partner Program?"
              />
            </div>

            <p className="white_text">
              The Profcyma Partner Program empowers you to{" "}
              <b>launch your own EdTech business with zero investment</b> and
              leverage the fast-growing global online education market.
            </p>

            <div className="ul_tag_div">
              <p className="inner_white_text">As a Profcyma Partner, you will:</p>

              <ul>
                {points.map((item, index) => (
                  <li key={index}>
                    <img
                      src={
                        process.env.PUBLIC_URL +
                        "/assets/images/home/partner_program/check.png"
                      }
                      className="check_img"
                      alt="check"
                    />
                   <p><b>{item.bold}</b> {item.text}</p> 
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Profcyma_Partner_Program;
